import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ParticipantTable from "../components/participantTable/ParticipantTable";
import { selectEventParticipantTableData } from "../../eventReducer";
import allActions from "../../../actions/allActions";
import { useParams } from "react-router-dom";
import { EventParamTypes } from "../../../types/types";
import { BreadCrumb } from "../../../components/breadcrumbs/BreadCrumb";
import { BreadRoute } from "../../../components/breadcrumbs/BreadRoute";

interface Props {}

export const EventParticipants: React.FC<Props> = () => {
  const { id } = useParams<EventParamTypes>();
  const {
    table,
    participants,
    startingTableHeaders,
    initLoading,
  } = useSelector((state) => selectEventParticipantTableData(state, id));
  const dispatch = useDispatch();

  const openParticipant = (subEventId: string, uuid: string) => {
    dispatch(
      allActions.participantActions.getParticipantDetails(subEventId, uuid)
    );
  };

  return (
    <div className='container w-screen h-screen'>
      <BreadRoute>
        <BreadCrumb label={"menu"} link={"/eventmenu"} />
        <BreadCrumb label={"events"} link={"/events"} />
        <BreadCrumb label={`event ${id}`} link={`/events/${id}`} />
        <BreadCrumb
          label={`participants`}
          link={`/events/${id}/participants`}
          lastChild={true}
        />
      </BreadRoute>
      <ParticipantTable
        open={openParticipant}
        list={participants}
        tableList={table}
        headerRow={startingTableHeaders}
        loading={initLoading}
      />
    </div>
  );
};

export default EventParticipants;
